export default __webpack_public_path__ + "static/media/icons-setting.289191f1.svg";